import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { ITheme } from '@uifabric/styling';
import { peoplePickerAddOptionalPeoplePlaceHolder } from 'owa-locstrings/lib/strings/peoplepickeraddoptionalpeopleplaceholder.locstring.json';
import loc from 'owa-localize';
import { getOptionalRecipientWellViewState } from 'owa-calendar-compose-form-store/lib/utils/getRecipientWellViewState';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { CalendarIcons } from 'owa-calendar-icons';
import {
    updateOptionalAttendees,
    enableFocusOptionalAttendeeWellOnMount,
} from 'owa-calendar-compose-form-actions';
import EditableAttendeeRow from './EditableAttendeeRow';
import {
    shouldShowOptionalAttendeeRow,
    shouldFocusOptionalAttendeeWellOnMount,
} from 'owa-calendar-compose-form-store/lib/selectors/attendeeRowUtils';
import RecipientType from 'owa-recipient-types/lib/types/RecipientType';
import { galOptionalAttendees } from './AttendeeRows.locstring.json';

export interface OptionalAttendeeRowProps {
    colorScheme: ColorScheme;
    theme: ITheme;
    showAvailability?: boolean;
}

const OptionalAttendeeRow: React.FunctionComponent<OptionalAttendeeRowProps> = props => {
    const { event } = getComposeStore();
    const { colorScheme, theme, showAvailability } = props;
    const shouldShowOptionalRow = shouldShowOptionalAttendeeRow();
    const shouldFocusOnMount = shouldFocusOptionalAttendeeWellOnMount();

    React.useEffect(() => {
        if (shouldShowOptionalRow && shouldFocusOnMount) {
            enableFocusOptionalAttendeeWellOnMount(false);
        }
    }, [shouldShowOptionalRow, shouldFocusOnMount]);

    if (!shouldShowOptionalRow) {
        return null;
    }

    return (
        <EditableAttendeeRow
            colorScheme={colorScheme}
            theme={theme}
            getWellViewState={getOptionalRecipientWellViewState}
            onAttendeesChanged={updateOptionalAttendees}
            placeholder={loc(peoplePickerAddOptionalPeoplePlaceHolder)}
            attendees={event.OptionalAttendees}
            iconName={CalendarIcons.UserOptional}
            shouldFocusOnMount={shouldFocusOnMount}
            showAvailability={showAvailability}
            galAriaLabel={loc(galOptionalAttendees)}
            recipientType={RecipientType.OptionalAttendee}
        />
    );
};

export default observer(OptionalAttendeeRow);
